/**
 * Fires a PostHog $pageview on every React Router location change.
 *
 * Place once near the root of the routed tree (inside <Router>).
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/posthog';

export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname, {
      search: location.search,
      hash: location.hash,
    });
  }, [location.pathname, location.search, location.hash]);
}
